module.exports = __webpack_public_path__ + "img/symbol_8.f79691c8.png";